import { Record, List } from "immutable";

export function paymentAuthorizationFromJSON(json: Partial<IPaymentAuthorizationData>) {
  return new PaymentAuthorizationRecord(json);
}

export const paymentProviders = List(["occ_pay", "pay_simple"]);

export interface IPaymentAuthorizationData {
  orgId: number;
  pay_simple: boolean;
  occ_pay: boolean;
}

export interface IPaymentAuthorizationRecord extends IPaymentAuthorizationData {
  loading: boolean;
  errors: List<string>;
}

const defaultPaymentAuthProps: IPaymentAuthorizationRecord = {
  orgId: -1,
  pay_simple: false,
  occ_pay: false,

  loading: false,
  errors: List<string>(),
};

export class PaymentAuthorizationRecord
  extends Record(defaultPaymentAuthProps)
  implements IPaymentAuthorizationRecord {}
